
import { Component, OnInit, Inject, ViewEncapsulation, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { UserProfileComponent } from '../user-profile/user-profile.component';
import { UserProfileService } from '../user-profile/user-profile.service';
import { LanguageService } from '../../../core/language/language.service';
import { AuthService } from '../../../core/auth/auth.service';
import { ItauUserIdleService } from '../../../core/security/itau-user-idle.service';
import { Menu } from '../menu/menu.model';

@Component({
  selector: 'app-header-container',
  templateUrl: './header-container.component.html',
  styleUrls: ['./header-container.component.css'],
})

export class HeaderContainerComponent implements OnInit {

  profile: UserProfileComponent;
  myControl = new FormControl();
  contextOpen: boolean;
  searchBarIsFocused: boolean;
  menu: Array<Menu>;
  @Inject('Window') _window;

  @Input()
  showheader: boolean;

  @Input() initialTabindex:number;

  constructor(public userProfileService: UserProfileService, private itauUserIdleService: ItauUserIdleService,public languageService: LanguageService, public authService: AuthService) {
    this.profile = new UserProfileComponent(userProfileService, itauUserIdleService, languageService, authService, this._window, null, null);

  }

  ngOnInit() {

    this.contextOpen = false;
  }

  onIsFocused(event: boolean) {

    this.searchBarIsFocused = event;
  }

  openContext(): void {

    this.contextOpen = true;
  }

  onCloseContext(closeEvent: boolean): void {

    this.contextOpen = !closeEvent;
  }

  onMenuRetrieval(retrievedMenu: Array<Menu>) {

    this.menu = retrievedMenu;
  }
}
